<script setup>
import { computed } from "vue";
import { useCompanyStore } from "@/storePinia/company";
import { storeToRefs } from "pinia";
import { getTrialDaysLeft } from "@/views/ecommerce/subscription/subscriptionHelpers";

const { company } = storeToRefs(useCompanyStore());

const trialDaysLeft = computed(() =>
  company.value.subscriptionStatus === "trial"
    ? getTrialDaysLeft(company.value.trialEndDate)
    : 0,
);
const isVisibleTrial = computed(() => trialDaysLeft.value > 0);
</script>

<template>
  <div
    v-if="isVisibleTrial"
    class="persistent-banner px-3 pt-2 pt-md-2 pb-2 d-flex flex-column gap-2"
  >
    <div
      v-if="isVisibleTrial"
      class="col-lg-12 mx-auto text-center text-sm"
      role="alert"
    >
      <span class="badge badge-sm badge-info"
        >Тестовий період. Залишилось днів:</span
      >
      <span class="badge badge-sm badge-info ms-1">{{ trialDaysLeft }}</span>
      <br />
      Щоб зберегти доступ
      <b
        ><router-link
          to="/subscription"
          class="persistent-banner__subscribe-link fw-semibold text-decoration-underline"
          >підпишіться</router-link
        ></b
      >
    </div>
  </div>
</template>

<style scoped>
.persistent-banner__subscribe-link {
  color: #0f4432;
}
</style>
